// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a760210e","498":"773acf13","703":"33641c2f","787":"28cb53c9"}[chunkId] + ".chunk.js";
};